import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Painel branco com cabeçalho (título + filtros), usado nas listagens. */
export function Panel({
  title,
  count,
  actions,
  children,
  className,
}: {
  title?: ReactNode;
  count?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('overflow-hidden rounded-xl border bg-white shadow-card', className)}>
      {(title || actions) && (
        <div className="flex flex-col gap-3 border-b px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
          {title && (
            <h2 className="font-display text-[15px] font-bold">
              {title}
              {count !== undefined && (
                <small className="ml-2 font-sans text-xs font-normal text-muted-foreground">{count}</small>
              )}
            </h2>
          )}
          {actions && <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

/** Card de seção da tela de OS (ícone laranja + título), como `.detail-card` do protótipo. */
export function SectionCard({
  icon,
  title,
  actions,
  children,
  className,
  description,
}: {
  icon: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  description?: ReactNode;
}) {
  return (
    <section className={cn('rounded-xl border border-[#dfe6ef] bg-white p-4 shadow-soft sm:p-5', className)}>
      <div className="mb-4 flex flex-wrap items-center gap-2.5">
        <span
          className="grid h-[31px] w-[31px] shrink-0 place-items-center rounded-[9px] bg-accent text-primary [&_svg]:h-4 [&_svg]:w-4"
          aria-hidden
        >
          {icon}
        </span>
        <h3 className="font-display text-[15px] font-bold">{title}</h3>
        {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {description && <p className="-mt-2 mb-3 text-[11px] text-[#718299]">{description}</p>}
      {children}
    </section>
  );
}
